import { STATUS_LABELS, STATUS_DOT } from '../../utils/constants';

/**
 * İş durum geçiş zaman çizelgesi — Sprint 2.10 FIELD-STAFF GÖREV 3.
 *
 * JobDetail'deki inline "Durum Geçmişi" listesinden EXTRACT edildi + ENHANCE:
 *   - KORUNAN: old→new STATUS_LABELS + note + tr-locale tarih/saat (davranış birebir)
 *   - ENHANCE: user_name (backend veriyordu, gösterilmiyordu) + STATUS_DOT renkli
 *     dot (gri yerine status-renkli) + boş durum mesajı (gizleme yerine).
 *
 * Not: tarih biçimi date-fns yerine native Intl (tr-TR) ile — date-fns/locale ESM'i
 * Jest tarafından transform edilmiyor; native bağımlılık-hafif + test edilebilir.
 * tr-locale saat gösterimi korunur (biçim motoru değişti, davranış aynı).
 *
 * Veri: job.status_history (getJob ile zaten gelir — yeni fetch yok).
 * Her event: { old_status, new_status, note, created_at, user_name }.
 *
 * @param {{ statusHistory?: Array<object> }} props
 */
function fmtDateTime(ts) {
  if (!ts) return null;
  return new Date(ts).toLocaleString('tr-TR', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
}

export function JobStatusTimeline({ statusHistory }) {
  const events = Array.isArray(statusHistory) ? statusHistory : [];
  // created_at artan sıralı (eskiden yeniye) — backend sırasına güvenme.
  const sorted = [...events].sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    return ta - tb;
  });

  return (
    <div>
      <p className="text-sm font-medium text-slate-700 mb-2">Geçmiş</p>
      {sorted.length === 0 ? (
        <p className="text-xs text-slate-400">Durum geçişi yok</p>
      ) : (
        <div className="space-y-2">
          {sorted.map((h, i) => (
            <div key={i} className="flex items-start gap-2 text-xs text-slate-500">
              <div className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${STATUS_DOT[h.new_status] || 'bg-slate-400'}`} />
              <span>
                {h.old_status ? `${STATUS_LABELS[h.old_status]} → ` : ''}
                <span className="font-medium text-slate-700">{STATUS_LABELS[h.new_status] || h.new_status}</span>
                {h.user_name && <span className="text-slate-400"> · {h.user_name}</span>}
                {h.note && ` · ${h.note}`}
                {h.created_at && ` · ${fmtDateTime(h.created_at)}`}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
